import { getPathLanguage, withLanguagePath } from '@/lib/url-language-utils'
import { useLayoutEffect } from 'react'

export function NotFoundPage() {
  const homePath = withLanguagePath(
    '/',
    typeof window === 'undefined'
      ? 'en'
      : getPathLanguage(window.location.pathname) ?? 'en',
  )

  useLayoutEffect(() => {
    document.title = 'Page not found | Mentiss AI'
    document.head.querySelectorAll(
      'link[rel="canonical"], link[rel="alternate"][hreflang], '
      + 'link[rel="prev"], link[rel="next"], script[type="application/ld+json"], '
      + 'meta[property^="og:"], meta[name^="twitter:"], '
      + 'meta[name="description"], meta[name="robots"]',
    ).forEach(element => element.remove())

    const robots = document.createElement('meta')
    robots.name = 'robots'
    robots.content = 'noindex,nofollow'
    document.head.append(robots)

    return () => robots.remove()
  }, [])

  return (
    <main className="mx-auto flex min-h-[70vh] max-w-3xl flex-col justify-center px-6 py-24" lang="en">
      <p className="text-sm font-semibold uppercase tracking-widest text-muted-foreground">404</p>
      <h1 className="mt-3 text-3xl font-bold text-foreground">Page not found</h1>
      <p className="mt-4 text-muted-foreground">
        This page does not exist. Check the address or return to the homepage.
      </p>
      <a className="mt-6 w-fit font-medium text-primary underline" href={homePath}>
        Return to homepage
      </a>
    </main>
  )
}
